import * as React from 'react';
import styled from 'styled-components';

import PulseIcon from '../../shared/components/icons/taskIcons/PulseIcon';
import t from '../../shared/translations';

const H3 = styled.h3`
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
        width: 26px;
        height: 26px;
        flex-shrink: 0;
    }
`;

function PulseInfo(): JSX.Element {
    return <>
        <H3>
            <PulseIcon />
            {t('player.pulse-landing.heading-info')}
        </H3>
        <p>{t('player.pulse-landing.info-process-steps')}</p>
        <ol>
            <li>{t('player.pulse-landing.info-process-step-1')}</li>
            <li>{t('player.pulse-landing.info-process-step-2')}</li>
            <li>{t('player.pulse-landing.info-process-step-3')}</li>
        </ol>
    </>;
}

export default PulseInfo;
